(function() {
    'use strict';

    angular.module('paysera.toast', ['ngToast']);
})();
